import React, { Component } from 'react';
import { Resizable } from 'react-resizable';
import { Table } from 'antd';

import './index.less';

const ResizeableTitle = (props) => {
    const { onResize, width, ...restProps } = props;

    if (!width) {
        return <th {...restProps} />;
    }

    return (
        <Resizable width={width} height={0} onResize={onResize}>
            <th {...restProps} className={restProps.col.isSelected && !restProps.col.isRowHeader ? "treenode-selected" : "th-default"} >
                <div style={{ width: restProps.col.width }}>
                    {restProps.col.isRowHeader ? null : <div className="name td-content" title={restProps.col.title}>{restProps.col.title}</div>}
                    {restProps.col.isRowHeader ? null : <div className="type td-content" title={restProps.col.type}>{restProps.col.type}</div>}
                    {(restProps.col.isRowHeader || !restProps.col.headerDropdown) ? null : <div className="dropdown">{restProps.col.headerDropdown}</div>}
                </div>
            </th>
        </Resizable>
    );
};

export default class ResizableDatatable extends Component {

    state = {
        columns: [],
        selectedRows: [],
        selectedItem: null,
    }

    components = {
        header: {
            cell: ResizeableTitle,
        },
    };

    componentWillReceiveProps(nextProps) {
        if (this.state.columns !== nextProps.columns)
            this.setState({ columns: nextProps.columns });
    }

    componentDidMount() {
        this.setState({ columns: this.props.columns });
    }

    handleResize = index => (e, { size }) => {

        if (size.width < 50)
            size.width = 50;

        this.setState(({ columns }) => {
            const nextColumns = [...columns];
            nextColumns[index].width = size.width;
            return { columns: nextColumns };
        });
    };

    onClickRow(rowIndex, record, event) {

        // console.log(record);
        // console.log(rowIndex);

        this.setState({ selectedRows: [rowIndex], selectedItem: record });
    }

    render() {

        const columns = this.state.columns.map((col, index) => ({
            ...col,
            render: (text, item) => {
                return <div className={"td-content " + (col.isRowHeader && !col.isSelected && this.state.selectedRows.length > 0 && item.key === this.state.selectedItem.key ? "treenode-selected " : "") + (!col.isRowHeader && col.isSelected && this.state.selectedRows.length > 0 && item.key === this.state.selectedItem.key ? "ant-pagination-item-active" : "td-default")} onClick={c => {
                    this.state.columns.forEach(c => c.isSelected = false);
                    col.isSelected = true;
                    this.setState({});
                }} style={{ width: this.state.columns[index].width }}>{col.render ? col.render(text, item) : text}</div>;
            },
            onHeaderCell: column => ({
                width: column.width,
                onResize: this.handleResize(index),
                col: col,
            }),
        }));

        return (
            <Table
                bordered
                className={`resizable-datatable ${this.props.className}`}
                pagination={this.props.pagination || false}
                style={this.props.style}
                components={this.components}
                columns={columns}
                scroll={this.props.scroll}
                dataSource={this.props.items}
                onRow={(record, rowIndex) => {
                    return {
                        onClick: event => this.onClickRow(rowIndex, record, event), // click row
                    };
                }}> </Table>
        );
    }
}
